// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_Rj","postedByDate":"e_Sj","container":"e_Tj","description":"e_Uj","title":"e_Vj"};